import ProductCardController from './product-card-controller'

export default ProductCardController
